import { render, staticRenderFns } from "./GestionSatisfaccion.vue?vue&type=template&id=12522954&"
import script from "./GestionSatisfaccion.vue?vue&type=script&lang=js&"
export * from "./GestionSatisfaccion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports